module.exports = __webpack_public_path__ + "static/media/Dream_SE_SV.c7865be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_SE_SV.png
// module id = 551
// module chunks = 0